"use client";

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["disableFlex", "error", "label", "tooltip", "helper", "prefixNode", "suffixNode", "className", "onClick", "borderless", "id", "aria-label", "errorPositionType", "maxLength", "hideCharacterCount", "isButton", "inputBoxRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Core } from "@faire/design-tokens";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Row } from "@faire/web--source/slate/Layout";
import { Typography, TypographyStyles } from "@faire/web--source/slate/Typography";
import { HIGH_VIS_FILTER, highVisSlateComponent } from "@faire/web--source/slate/utils/highVisSlateComponent";
import { useUniqueId } from "@faire/web--source/ui/hooks/useUniqueId";
import * as React from "react";
import styled, { css, useTheme } from "styled-components";
import { getSpacing, Spacer } from "../spacing";
import { themeOrDefault } from "../Theme";
import { getDerivedPropsFromErrorProps } from "./error";
var inputBorderFocusStyles = css(["&:focus,&:focus-within{border:1px solid ", ";}"], Core.border.default);
export var inputBorderStyles = css(["border:1px solid ", ";&:invalid{border:1px solid ", ";}", ";"], function (props) {
  return props.$showErrorState ? Core.border.critical : Core.border.muted;
}, Core.border.critical, inputBorderFocusStyles);
export var INPUT_HEIGHT = 42;
export var disabledInputStylesNoBorder = css(["background-color:", ";cursor:default;"], Core.surface.subdued);
export var inputStylesNoBorder = css(["", ";appearance:none;border:none;outline:none;padding:0 16px;&:invalid{appearance:none;box-shadow:none;}&::placeholder{color:", ";}&:disabled{", ";}", ";"], function (props) {
  return TypographyStyles({
    color: props.disabled ? Core.text.subdued : Core.text.default
  });
}, function (_ref) {
  var _themeOrDefault$input;
  var theme = _ref.theme;
  return (_themeOrDefault$input = themeOrDefault(theme).input.placeholder.color) !== null && _themeOrDefault$input !== void 0 ? _themeOrDefault$input : Core.text.subdued;
}, disabledInputStylesNoBorder, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? disabledInputStylesNoBorder : "";
});
export var inputStyles = css(["", ";", ";"], inputStylesNoBorder, inputBorderStyles);
export var InputWrapper = styled(Row).attrs({
  align: "center"
}).withConfig({
  displayName: "Input__InputWrapper"
})(["", ";height:", "px;padding:0 16px;background:", ";cursor:text;", ";", ""], function (_ref3) {
  var borderless = _ref3.$borderless;
  return !borderless ? inputBorderStyles : inputBorderFocusStyles;
}, INPUT_HEIGHT, Core.surface.inverse, function (_ref4) {
  var disabled = _ref4.$disabled;
  return disabled ? css(["background-color:", ";"], Core.surface.subdued) : "";
}, highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
var InvisibleInput = styled.input.withConfig({
  displayName: "Input__InvisibleInput"
})(["", ";padding:0;@supports (display:flex){width:0;flex:1 1 auto;}background:none;cursor:inherit;border:0 !important;"], inputStylesNoBorder);
export var FormInputLabel = styled.label.withConfig({
  displayName: "Input__FormInputLabel"
})(["", ";"], function (_ref5) {
  var $typography = _ref5.$typography;
  return TypographyStyles($typography !== null && $typography !== void 0 ? $typography : {});
});
var Wrapper = styled.div.withConfig({
  displayName: "Input__Wrapper"
})(["position:relative;flex:", ";input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}input[type=\"number\"]{-moz-appearance:textfield;}width:100%;"], function (props) {
  return props.$disableFlex ? "none" : 1;
});
var getAriaLabelProps = function getAriaLabelProps(ariaLabel, labelId) {
  if (ariaLabel) {
    return {
      "aria-label": ariaLabel
    };
  } else if (labelId) {
    return {
      "aria-labelledby": labelId
    };
  } else {
    return {};
  }
};
/**
 * @trackcomponent
 *
 * @link [Docs](https://slate.faire.team/slate/component/input/web/input)
 */
export var Input = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var _props$value, _input$label;
  var disableFlex = _ref6.disableFlex,
    error = _ref6.error,
    label = _ref6.label,
    tooltip = _ref6.tooltip,
    helper = _ref6.helper,
    prefixNode = _ref6.prefixNode,
    suffixNode = _ref6.suffixNode,
    className = _ref6.className,
    _onClick = _ref6.onClick,
    borderless = _ref6.borderless,
    id = _ref6.id,
    ariaLabel = _ref6["aria-label"],
    errorPositionType = _ref6.errorPositionType,
    maxLength = _ref6.maxLength,
    hideCharacterCount = _ref6.hideCharacterCount,
    _ref6$isButton = _ref6.isButton,
    isButton = _ref6$isButton === void 0 ? true : _ref6$isButton,
    inputBoxRef = _ref6.inputBoxRef,
    props = _objectWithoutProperties(_ref6, _excluded);
  var defaultId = useUniqueId("input-");
  var _useTheme = useTheme(),
    input = _useTheme.input;
  var defaultRef = React.useRef(null);
  var innerRef = ref !== null && ref !== void 0 ? ref : defaultRef;
  var _getDerivedPropsFromE = getDerivedPropsFromErrorProps({
      error: error
    }),
    showErrorState = _getDerivedPropsFromE.showErrorState,
    showErrorMessage = _getDerivedPropsFromE.showErrorMessage,
    errorMessage = _getDerivedPropsFromE.errorMessage;
  var inputId = id !== null && id !== void 0 ? id : defaultId;
  var labelId = label ? "".concat(inputId, "__label") : undefined;
  var value = (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : "";
  var ariaLabelProps = getAriaLabelProps(ariaLabel, labelId);
  var shouldShowCharacterCount = !hideCharacterCount && !!maxLength;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "$disableFlex": disableFlex
  }, label ? (/*#__PURE__*/React.createElement(FormInputLabel, {
    id: labelId,
    "$typography": _objectSpread(_objectSpread({}, (_input$label = input.label) !== null && _input$label !== void 0 ? _input$label : {}), {}, {
      color: showErrorState ? Core.text.critical : input.label.color
    }),
    htmlFor: inputId
  }, tooltip ? (/*#__PURE__*/React.createElement(Row, null, label, /*#__PURE__*/React.createElement(Spacer, {
    size: "1x"
  }), tooltip)) : label)) : null, /*#__PURE__*/React.createElement(InputWrapper, {
    className: className,
    "$disabled": props.disabled,
    "$showErrorState": showErrorState,
    onClick: function onClick(e) {
      var _innerRef$current;
      innerRef === null || innerRef === void 0 ? void 0 : (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.focus();
      if (!props.disabled) {
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
      }
    },
    role: isButton ? "button" : "",
    "$borderless": borderless,
    ref: inputBoxRef
  }, isNotUndefined(prefixNode) ? (/*#__PURE__*/React.createElement(React.Fragment, null, typeof prefixNode === "string" ? (/*#__PURE__*/React.createElement(Typography, null, prefixNode)) : prefixNode, /*#__PURE__*/React.createElement(Spacer, {
    size: 8
  }))) : null, /*#__PURE__*/React.createElement(InvisibleInput, _objectSpread(_objectSpread(_objectSpread({
    ref: innerRef,
    placeholder: "",
    maxLength: maxLength
  }, props), ariaLabelProps), {}, {
    id: inputId
  })), isNotUndefined(suffixNode) ? (/*#__PURE__*/React.createElement(React.Fragment, null, typeof suffixNode === "string" ? (/*#__PURE__*/React.createElement(Typography, {
    color: props.disabled ? Core.text.disabled : Core.text.default
  }, suffixNode)) : suffixNode)) : null), shouldShowCharacterCount || errorMessage || helper ? (/*#__PURE__*/React.createElement(FooterSection, {
    errorMessage: errorMessage,
    showErrorMessage: showErrorMessage,
    errorPositionType: errorPositionType,
    helper: helper,
    maxLength: maxLength,
    shouldShowCharacterCount: shouldShowCharacterCount,
    value: value
  })) : null);
});
var HelperOrErrorText = function HelperOrErrorText(_ref7) {
  var helper = _ref7.helper,
    errorMessage = _ref7.errorMessage,
    showErrorMessage = _ref7.showErrorMessage,
    errorPositionType = _ref7.errorPositionType;
  if (showErrorMessage) {
    if (errorPositionType) {
      return /*#__PURE__*/React.createElement(AbsoluteErrorMessage, {
        variant: "labelSansRegular",
        color: Core.text.critical,
        "data-test-id": "input-error-message"
      }, errorMessage);
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
        variant: "labelSansRegular",
        color: Core.text.critical
      }, errorMessage));
    }
  } else {
    return /*#__PURE__*/React.createElement(Typography, {
      variant: "labelSansRegular",
      color: Core.text.default,
      "data-test-id": "input-helper-message"
    }, helper);
  }
};
var FooterSection = function FooterSection(_ref8) {
  var helper = _ref8.helper,
    errorMessage = _ref8.errorMessage,
    showErrorMessage = _ref8.showErrorMessage,
    errorPositionType = _ref8.errorPositionType,
    maxLength = _ref8.maxLength,
    shouldShowCharacterCount = _ref8.shouldShowCharacterCount,
    value = _ref8.value;
  var textColor = showErrorMessage ? Core.text.critical : Core.text.default;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: 4
  }), /*#__PURE__*/React.createElement(Row, {
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(HelperOrErrorText, {
    helper: helper,
    errorMessage: errorMessage,
    showErrorMessage: showErrorMessage,
    errorPositionType: errorPositionType
  }), shouldShowCharacterCount ? (/*#__PURE__*/React.createElement(Typography, {
    variant: "labelSansRegular",
    color: textColor
  }, value === null || value === void 0 ? void 0 : value.length, "/", maxLength)) : null));
};
var AbsoluteErrorMessage = styled(Typography).withConfig({
  displayName: "Input__AbsoluteErrorMessage"
})(["position:absolute;bottom:", ";transform:translateY(100%);"], getSpacing(-4));